import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { IconButtonComponent } from '../../common/button/components/icon-button/icon-button.component';
import { RtTooltip } from '../../common/tooltip/tooltip.directive';

@Component({
  selector: 'rt-dialog-close',
  styleUrls: ['./dialog-close.component.less'],
  template: `
    <rt-icon-button
      variant="plain-onoverlay"
      [rtTooltip]="closeTooltip! | translate"
      [rtTooltipPosition]="'left'"
      iconName="close"
      shape="square"
    >
    </rt-icon-button>
  `,
  standalone: true,
  imports: [IconButtonComponent, RtTooltip, TranslatePipe],
})
export class DialogCloseComponent {
  @Input() public closeTooltip?: string = 'rtu.dialog.close_tooltip';
}
